import gql from "graphql-tag";
const invokeApiQuery = gql(` 
query invoke($event: AWSJSON!) {
  invoke(event: $event) {
    status
  }
}
`)
export default invokeApiQuery;